import {Color} from 'components/system/colors';

export const difficultyLevels = {
  Easy: 1,
  Medium: 2,
  Hard: 3,
} as const;

export const difficultyLevelNames: Record<DifficultyLevelType, string> = {
  [difficultyLevels.Easy]: 'Easy',
  [difficultyLevels.Medium]: 'Medium',
  [difficultyLevels.Hard]: 'Hard',
};

export const difficultyLevelColors: Record<DifficultyLevelType, Color> = {
  [difficultyLevels.Easy]: 'green',
  [difficultyLevels.Medium]: 'orange',
  [difficultyLevels.Hard]: 'red',
};

export const difficultyLevelOptions: {value: DifficultyLevelType; label: string}[] = [
  {value: difficultyLevels.Easy, label: difficultyLevelNames[difficultyLevels.Easy]},
  {value: difficultyLevels.Medium, label: difficultyLevelNames[difficultyLevels.Medium]},
  {value: difficultyLevels.Hard, label: difficultyLevelNames[difficultyLevels.Hard]},
];

export type DifficultyLevelType = typeof difficultyLevels[keyof typeof difficultyLevels];
